import React from "react";
import {
  LinkedResource,
  ProductDisclaimer,
  ProductDocument,
} from "~/ProductDetails/ProductDetailPageResult";
import LinkedResources from "./LinkedResources";
import ProductDocuments from "./ProductDocuments";

interface Props {
  manufacturerItemNumberDisplayText: string;
  productDocuments?: ProductDocument[];
  productDisclaimer?: ProductDisclaimer;
  linkedResources?: LinkedResource[];
}

const ResourcesAndDownloads = ({
  manufacturerItemNumberDisplayText,
  productDocuments,
  productDisclaimer,
  linkedResources,
}: Props) => {
  const resourcesAndDownloadsHeader = (
    <h3 data-testid="ResourcesAndDownloadsHeader" id="resources-group-header">
      {`Resources${productDocuments?.length ? " and Downloads" : ""}`}
      {manufacturerItemNumberDisplayText?.length > 0 && (
        <>
          &nbsp;for <br /> {manufacturerItemNumberDisplayText}
        </>
      )}
    </h3>
  );

  return (
    <>
      {(productDocuments?.length ||
        productDisclaimer?.warrantyInformation ||
        (linkedResources && linkedResources.length > 0)) && (
        <div
          id="resources-group"
          className="box padded clearfix"
          style={{ scrollMarginTop: "113px" }}
        >
          {resourcesAndDownloadsHeader}
          {productDocuments && productDocuments?.length > 0 && (
            <div className="downloads">
              <ProductDocuments productDocuments={productDocuments} />
              <p className="download_info">
                A PDF viewer is required to view this product&apos;s
                information.{" "}
                <a
                  target="adobe"
                  href="https://get.adobe.com/reader/"
                  rel="nofollow"
                  title="Download Adobe Reader"
                  className="underline"
                >
                  Download Adobe Acrobat software
                </a>
              </p>
            </div>
          )}
          {productDisclaimer?.showWarrantyInformation &&
            productDisclaimer?.warrantyInformation && (
              <div className="resources warranty-info">
                <p className="header-4">Warranty Info</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: productDisclaimer.warrantyInformation,
                  }}
                />
              </div>
            )}
          {linkedResources && linkedResources.length > 0 && (
            <LinkedResources
              linkedResources={linkedResources}
              displaySubheader={!!productDocuments?.length}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ResourcesAndDownloads;
